import { render, staticRenderFns } from "./IconQrcodeSolid.vue?vue&type=template&id=04a143f6"
import script from "./IconQrcodeSolid.vue?vue&type=script&lang=js"
export * from "./IconQrcodeSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports